import { translationConstants, genderEnum } from "../../../../constants";

export const genderOptions = (t) => [
  {
    label: t(translationConstants.male),
    value: genderEnum.MALE,
  },
  {
    label: t(translationConstants.female),
    value: genderEnum.FEMALE,
  },
  {
    label: t(translationConstants.MIXED),
    value: genderEnum.MIXED,
  },
];

export const LocationSelectionConstants = {
  PUBLIC_SPOT: 0,
  PRIVATE_SPOT: 1,
  CUSTOM_LOCATION: 2,
};
